import { SelectField } from '@components/molecules/SelectField'
import { scopedTranslation } from '@utils/I18n'
import { useController } from 'react-hook-form'
import gql from 'graphql-tag'
import useQuery from '@hooks/useQuery'

const tSupporterShow = scopedTranslation('supporter_show')

type EngagementLevelsData = {
  engagementLevels: {
    nodes: [
      {
        id: string
        name: string
      },
    ]
  }
}

export default function EngagementLevelSelect({ control }) {
  const AVAILABLE_ENGAGEMENT_LEVELS = gql`
    query getEngagementLevels {
      engagementLevels(isActive: true) {
        nodes {
          id
          name
        }
      }
    }
  `

  const response = useQuery<EngagementLevelsData>({
    key: 'engagementLevels',
    query: AVAILABLE_ENGAGEMENT_LEVELS,
    variables: {},
  })

  const engagementLevels = response.data?.engagementLevels?.nodes ?? []
  const options = [
    { value: '0', label: tSupporterShow('no_engagement_level') },
    ...engagementLevels.map((level) => ({ value: level.id, label: level.name })),
  ]

  const { field } = useController({
    name: 'supporter.engagementLevel',
    defaultValue: '0',
    control,
  })

  return (
    <SelectField
      name={field.name}
      label={tSupporterShow('engagement_level')}
      options={options}
      value={field.value}
      onValueChange={field.onChange}
    />
  )
}
